"use strict";

exports.__esModule = true;
exports.AggregateMetricChartElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _AggregateMetricSelector = require("./AggregateMetricSelector");
var _ErrorText = require("../common/AggregateMetricCharts/ErrorText");
var _Time = require("../../Time");
var _Device = require("../../Device");
var _MaxBinLimitWrapper = require("../common/MaxBinLimitWrapper");
var _dataFormatter = require("./dataFormatter");
var _Core = require("../../Core");
var _DataAccessorContext = require("../../API/DataInterface/DataAccessorContext");
var _Catalogs = require("../../../Catalogs");
var _AggsMetricChart = require("./ECharts/AggsMetricChart");
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var MetricSelectorWrapper = _styledComponents["default"].div.withConfig({
  displayName: "AggregateMetricChartElement__MetricSelectorWrapper",
  componentId: "sc-1fc6skn-0"
})(["display:flex;z-index:1;margin-left:0px;margin-bottom:10px;.", "{font-weight:600;}"], _core.Classes.BUTTON);
function getMetricQuery(_ref) {
  var device = _ref.device,
    metric = _ref.metric,
    interval = _ref.interval,
    aggregations = _ref.aggregations,
    timezoneName = _ref.timezoneName;
  var aggregationNames = aggregations.map(function (agg) {
    return agg.name;
  });
  var buildQuery = (0, _Catalogs.buildMetricQuery)([metric]);
  buildQuery.filterByDevice(device);
  buildQuery.filterByRange(new Date(interval.startMillis).toISOString(), new Date(interval.endMillis).toISOString());
  buildQuery.aggregateBy(aggregationNames, {
    timezoneName: timezoneName
  });
  return buildQuery.getQuery();
}
var AggregateMetricChartElement = exports.AggregateMetricChartElement = function AggregateMetricChartElement(props) {
  var time = _react["default"].useContext(_Time.TimeContext);
  var devicesList = _react["default"].useContext(_Device.DeviceListContext);
  var dataAccessor = _react["default"].useContext(_DataAccessorContext.DataAccessorContext);
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var timezone = time.timezone;
  var device = (0, _Device.useSelectedDevices)();
  var timePeriod = (0, _Time.useSelectionContext)();
  var hideXAxis = props.hideXAxis,
    hideXUnits = props.hideXUnits,
    showLegends = props.showLegends,
    showChartTooltip = props.showChartTooltip;
  var displayProps = {
    hideXAxis: hideXAxis,
    hideXUnits: hideXUnits,
    showLegends: showLegends,
    showChartTooltip: showChartTooltip
  };
  var _useState = (0, _react.useState)(props.metricChartSeries[0].metricName),
    selectedMetric = _useState[0],
    setSelectedMetric = _useState[1];
  var _useState2 = (0, _react.useState)(true),
    showTargets = _useState2[0],
    setShowTargets = _useState2[1];
  var _useState3 = (0, _react.useState)(props.metricChartSeries[0].metricName),
    targetsMetric = _useState3[0],
    setTargetsMetric = _useState3[1];
  (0, _react.useEffect)(function () {
    setSelectedMetric(props.metricChartSeries[0].metricName);
    setTargetsMetric(selectedMetric);
  }, [props.metricChartSeries, showTargets]);
  var width = props.width,
    height = props.height,
    aggregations = props.aggregations;
  var isTimeAggregated = aggregations.find(function (d) {
    return d.id === "workday";
  }) !== undefined;
  if (!isTimeAggregated) {
    return /*#__PURE__*/_react["default"].createElement(_ErrorText.ErrorText, {
      "data-testid": "error-message",
      width: width,
      height: height
    }, "Please select a time aggregation");
  }
  var timeAggregation = aggregations.find(function (d) {
    return d.id === "workday";
  });
  var timeAggregationName = (timeAggregation == null ? void 0 : timeAggregation.name) || "day";
  var query = getMetricQuery({
    device: device,
    metric: selectedMetric,
    interval: timePeriod.interval,
    timezoneName: timezone.name,
    aggregations: aggregations
  });
  return /*#__PURE__*/_react["default"].createElement(_MaxBinLimitWrapper.MaxBinLimitWrapper, {
    timeAggregationName: timeAggregationName
  }, /*#__PURE__*/_react["default"].createElement(_Core.AsyncLoader, {
    load: function load(query) {
      return dataAccessor.getFlattenedMetricsData(query);
    },
    params: query
  }, function (loaderProps) {
    return /*#__PURE__*/_react["default"].createElement(_Core.LoadingMediator, loaderProps, function (data) {
      if (data.length === 0) {
        return /*#__PURE__*/_react["default"].createElement(_ErrorText.ErrorText, {
          width: width,
          height: height
        }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "Widgets.NoData.Warning",
          defaultMessage: "No Data Available"
        }));
      }
      var targetsQuery = {
        metric: targetsMetric,
        scope: {
          device_id: devicesList.map(function (it) {
            return it.uuid;
          })
        },
        startWorkday: timePeriod.startPlantTime.toISOString().slice(0, 10),
        endWorkday: timePeriod.endPlantTime.toISOString().slice(0, 10)
      };
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(MetricSelectorWrapper, null, /*#__PURE__*/_react["default"].createElement(_AggregateMetricSelector.AggregateMetricSelector, {
        metricChartSeries: props.metricChartSeries,
        selected: [selectedMetric] || [],
        onSelect: function onSelect(_ref2) {
          var id = _ref2[0].id;
          setSelectedMetric(id);
          setTargetsMetric(id);
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginLeft: "10px",
          marginTop: "3px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_core.Switch, {
        label: translate("Chart.showTargets", "Show Targets"),
        checked: showTargets,
        onChange: function onChange() {
          setShowTargets(!showTargets);
        }
      }))), /*#__PURE__*/_react["default"].createElement(_Core.AsyncLoader, {
        load: function load(query) {
          return showTargets ? dataAccessor.getTargets(query) : Promise.resolve([]);
        },
        params: targetsQuery
      }, function (loaderProps) {
        return /*#__PURE__*/_react["default"].createElement(_Core.LoadingMediator, loaderProps, function (targets) {
          var dataProps = (0, _dataFormatter.formatMetricData)({
            data: data,
            selectedMetric: selectedMetric,
            aggregations: aggregations,
            devicesList: devicesList,
            timeAggregationName: timeAggregationName,
            time: time,
            targets: showTargets ? targets : []
          });
          return /*#__PURE__*/_react["default"].createElement(_AggsMetricChart.AggsMetricChart, {
            timePeriod: timePeriod,
            echartsProps: dataProps,
            displayProps: displayProps,
            targets: {
              targets: targets
            },
            width: width,
            height: height
          });
        });
      }));
    });
  }));
};